import React, { Component } from 'react'
import './AddSigneePopup.scss';
import moment from 'moment';
import { sparkDateValidation } from '../../helpers/validationHelper';

export default class MoreDetails extends Component {
    render() {
        const { closePopup, details } = this.props;
        let color_scheme;        
        if(details.color_schemes && details.color_schemes !== null) {
            let schems = JSON.parse(details.color_schemes);  
            if(schems !==null) {
                let convertValues = Object.values(schems);
                if(convertValues && convertValues.length > 0 && convertValues[0] && convertValues[0].name) {
                    color_scheme = convertValues[0].name
                }
            }
        }
        
        return (
            <div className='moreDetailspopupBg'>
                <div className='popupMain'>
                <div className='heddingPopup'>
                    <h4>Information</h4>
                </div>
                    <div onClick={closePopup} className='closePopup'><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                    </svg></div>
                    <div className='popupContent'>
                        <div className='contentText'>
                            <p className='fw-600'>Unit</p>
                            <p>{details.number}</p>
                        </div>
                        {details.stratalot &&
                            <div className='contentText'>
                                <p className='fw-600'>Strata lot</p>
                                <p>{details.stratalot}</p>
                            </div>}
                            {details.buildingName &&  
                        <div className='contentText'>
                            <p className='fw-600'>Building</p>
                            <p>{details.buildingName}</p>
                        </div>}
                        {details.floor &&  
                        <div className='contentText'>
                            <p className='fw-600'>Floor</p>
                        <p>{details.floor}</p>
                        </div>}
                        <div className='contentText'>
                            <p className='fw-600'>Status</p>
                            <p>{details.status}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Bedrooms</p>
                            <p>{details.bedrooms}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Bathrooms</p>
                            <p>{details.bathrooms}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Kind</p>
                            <p>{details.kind}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Floorplan id</p>
                            <p>{details.floorplan_id}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Floorplan name</p>
                            <p>{details.floorplan_name}</p>
                        </div>
                        <div className='contentText'>
                            <p className='fw-600'>Area (square footage)</p>
                            <p>{details.area}</p>
                        </div>
                        
                        {/* <div className='contentText'>
                            <p>Floorplan pdf</p>
                            <p>08</p>
                        </div> */}
                       
                        {details.parkingStalls && details.parkingStalls.length > 0 &&
                            <div className='contentText'>
                                <p className='fw-600'>Parking stall numbers</p>
                                {details.parkingStalls.map((ps, index) => {
                                    return (
                                        <p>{ps.name + (details.parkingStalls.length - 1 === index ? '' : ', ')}</p>
                                    )
                                })}
                            </div> }

                        {details.storageLockers && details.storageLockers.length > 0 &&
                            <div className='contentText'>
                                <p className='fw-600'>Storage locker numbers</p>
                                {details.storageLockers.map((ps, index) => {
                                    return (
                                        <p>{ps.name + (details.storageLockers.length - 1 === index ? '' : ', ')}</p>
                                    )
                                })}
                            </div>}

                        {color_scheme &&
                            <div className='contentText'>
                                <p className='fw-600'>Color scheme</p>
                                <p>{color_scheme}</p>
                            </div>}
                            {sparkDateValidation(details.estimated_closing_date) &&
                        <div className='contentText'>
                            <p className='fw-600'>Estimated closing date</p>
                             <p>{moment(details.estimated_closing_date).format('MM/DD/YYYY HH:mm:ss')}</p>
                        </div>}
                        {sparkDateValidation(details.estimated_completion) &&
                <div className='contentText'>
                    <p className='fw-600'>Estimated completion</p>
                    <p>{moment(details.estimated_completion).format('MM/DD/YYYY HH:mm:ss')}</p>
                </div>}
                {sparkDateValidation(details.estimated_move_in) &&
                <div className='contentText'>
                    <p className='fw-600'>Estimated move in</p>
                    <p>{moment(details.estimated_move_in).format('MM/DD/YYYY HH:mm:ss')}</p>
                </div>}
                {sparkDateValidation(details.updated_at) &&
                <div className='contentText'>
                    <p className='fw-600'>Updated at</p>
                <p>{moment(details.updated_at).format('MM/DD/YYYY HH:mm:ss')}</p>
                </div>}
                    </div>
                </div>
            </div>
        )
    }
}

